import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Grid,
  Alert,
} from "@mui/material";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import TicketSearch from "../../../../Components/TicketSearch";
import VitalSignsRecord from "../VitalSigns/VitalSignsRecord";
import NursingNoteCreateDialog from "./NursingNoteCreateDialog";

const QuickActionsByTicket = () => {
  const { t } = useTranslation();
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [vitalSignsOpen, setVitalSignsOpen] = useState(false);
  const [nursingNoteOpen, setNursingNoteOpen] = useState(false);

  const patientFromTicket = selectedTicket?.patient
    ? { id: selectedTicket.patient }
    : null;

  return (
    <Paper sx={{ p: 2, boxShadow: "0px 0px 0px" }}>
      <Typography variant="h6" gutterBottom fontWeight="bold">
        {t("nurse.quickActionsByTicket", "Quick Actions by Ticket")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("nurse.searchTicketToAdd", "Search by ticket number to add vital signs, nursing notes, or view patient profile.")}
      </Typography>

      <TicketSearch
        value={selectedTicket}
        onChange={setSelectedTicket}
        placeholder={t("nurse.searchByTicket", "Search by ticket number") || "Search by ticket number"}
        label={t("nurse.ticket", "Ticket")}
        size="small"
      />

      {selectedTicket && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            {t("nurse.ticket", "Ticket")}: {selectedTicket.ticket_number}
            {selectedTicket.patient_name_display &&
              ` · ${t("nurse.patient", "Patient")}: ${selectedTicket.patient_name_display}`}
          </Typography>
          <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                startIcon={<MonitorHeartIcon />}
                onClick={() => setVitalSignsOpen(true)}
              >
                {t("nurse.addVitalSigns", "Add Vital Signs")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                startIcon={<EventNoteIcon />}
                onClick={() => setNursingNoteOpen(true)}
              >
                {t("nurse.addNursingNote", "Add Nursing Note")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                startIcon={<PersonIcon />}
                component={Link}
                to={`/patient-profile/ticket/${selectedTicket.id}`}
              >
                {t("nurse.viewPatientProfile", "View Patient Profile")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}

      {!selectedTicket && (
        <Alert severity="info" sx={{ mt: 2 }}>
          {t("nurse.selectTicketToAdd", "Select a ticket to add vital signs, nursing notes, or view the patient profile.")}
        </Alert>
      )}

      <VitalSignsRecord
        open={vitalSignsOpen}
        onClose={() => setVitalSignsOpen(false)}
        patient={patientFromTicket}
        ticketId={selectedTicket?.id}
      />

      <NursingNoteCreateDialog
        open={nursingNoteOpen}
        onClose={() => setNursingNoteOpen(false)}
        patient={patientFromTicket}
      />
    </Paper>
  );
};

export default QuickActionsByTicket;
